<template>
  <div class="impression-tracker">
    <h4 class="impression-tracker-title">
      {{ $t("Impression Tracker  (Optional)") }}
    </h4>
    <h6 class="mb-8 impression-tracker-desc">
      {{ $t("You can add up to 3 trackers") }}
    </h6>
    <!-- table -->
    <div class="table-parent">
      <table class="impression-tracker-table">
        <tr class="impression-tracker-tr">
          <th class="impression-tracker-th tracker-type-width">Tracker Type</th>
          <th class="impression-tracker-th tracker-width">Tracker</th>
          <th class="impression-tracker-th">Actions</th>
        </tr>
        <tr
          v-for="(tracker, index) in value"
          :key="index + '-' + adsetIndex + '-' + adIndex"
        >
          <td class="impression-tracker-td">
            <div class="v-select-parent">
              <vx-input-group>
              <span v-bind:class="{ trackerTypeInputHasError: $vErrors.has([errors, serverErrors],`step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`)}" v-if="$hasFeature('impressions-tracker-tags')">
                <v-select
                  id="create-campaign-s5-tracker-list"
                  @input="clearImpressionsTrackerError(index)"
                  :clearable="false"
                  index="value"
                  :options="trackerTypes"
                  v-model="tracker.type"
                  :reduce="o => o.value"
                  label="text"
                  name="tracker_type"
                  placeholder="Choose Type"
                  class="tracker-type-dropdown"
                >
                </v-select>
                </span>
                <span v-bind:class="{ trackerTypeInputHasError: $vErrors.has([errors, serverErrors],`step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`)}" v-else class="impression-url-span">
                URL
                </span>
              </vx-input-group>
            </div>
          </td>

          <td class="tables-rows-vertical-align">
            <div class="impression-tracker-input-parent">
              <input
                id="create-campaign-s5-tracker-input"
                class="impression-tracker-input"
                placeholder="Type your tracker"
                v-model="tracker.value"
                type="text"
                data-vv-name="impression-tracker-input"
                v-bind:class="{ inputHasError: $vErrors.has([errors, serverErrors],`step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`) }"
              />
              <span v-if="errors.has('impression-tracker-input')" class="text-danger">
                {{ errors.first('impression-tracker-input') }}
              </span>
              <span
                v-else-if="
                  $vErrors.has(
                    [errors, serverErrors],
                    `step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`
                  )
                "
                class="text-danger"
              >
                {{
                  $vErrors.first(
                    [errors, serverErrors],
                    `step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`
                  )
                }}
              </span>
            </div>
          </td>

          <td class="impression-tracker-td tables-rows-vertical-align">
            <span v-bind:class="{ actionsInputHasError: $vErrors.has([errors, serverErrors],`step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`)}" class="tracker-actions add-tracker"
            v-if="value.length -1 == index && index != 2">
              <vx-tooltip
                class="tooltip"
                text="Add Onother Tracker"
                position="bottom"
              >
                <vs-icon
                  id="create-campaign-s5-add-tracker-button"
                  v-bind:class="{ disableAddIcon: tracker.value >= 0 || value.length == 3 }"
                  @click="addTracker"
                  icon="speakol-plus"
                  icon-pack="speakol"
                ></vs-icon>
              </vx-tooltip>
            </span>
            <span v-bind:class="{ actionsInputHasError: $vErrors.has([errors, serverErrors],`step5.adsets.${adsetIndex}.ads.${adIndex}.impressions_tracker.${index}.value`)}" class="tracker-actions remove-tracker"
            v-if="value.length > 1"
            >
              <vx-tooltip
                class="tooltip"
                text="Remove Tracker"
                position="bottom"
              >
                <vs-icon
                  id="create-campaign-s5-remove-tracker-button"
                  :class="{ disableRemoveIcon: value.length == 1 }"
                  @click="removeTracker(index)"
                  icon="speakol-cancel"
                  icon-pack="speakol"
                ></vs-icon>
              </vx-tooltip>
            </span>
          </td>
        </tr>
      </table>
    </div>
    <!-- table -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Array
    },
    adsetIndex: {
      required: true,
      type: Number
    },
    adIndex: {
      required: true,
      type: Number
    },
    serverErrors: {
      required: true
    }
  },
  data () {
    return {
      isAddDisable: true,
      isRemoveDisable: true
    }
  },
  computed: {
    trackerTypes () {
      const data = [
        {
          value: 'url',
          text: 'URL'
        }
      ]

      if (this.$hasFeature('impressions-tracker-tags')) {
        data.push({
          value: 'html',
          text: 'HTML Code'
        })
      }

      return data
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    clearImpressionsTrackerError (index) {
      this.serverErrors.remove(`step5.adsets.${this.adsetIndex}.ads.${this.adIndex}.impressions_tracker.${index}.value`)
      this.errors.remove(`step5.adsets.${this.adsetIndex}.ads.${this.adIndex}.impressions_tracker.${index}.value`)
    },
    addTracker () {
      if (this.value[this.value.length - 1].value === '' || this.value[this.value.length - 1].value === null) {
        return
      }

      if (this.value.length > 2) {
        return
      }

      this.value.push({
        type: 'url',
        value: null
      })
    },
    removeTracker (index) {
      if (this.value.length > 1) {
        this.value.splice(index, 1)
        this.serverErrors.remove(`step5.adsets.${this.adsetIndex}.ads.${this.adIndex}.impressions_tracker.${index}.value`)
        this.errors.remove(`step5.adsets.${this.adsetIndex}.ads.${this.adIndex}.impressions_tracker.${index}.value`)
      }
    }
  }
}
</script>

<style lang="scss">
.impression-tracker-title {
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
  margin-top: 40px;
}

.impression-tracker-desc {
  font-weight: normal;
  font-size: 12px;
  margin-top: 12px;
  color: #999;
  font-weight: normal;
}

.impression-tracker-table {
  width: 100%;
  border-collapse: collapse;

  table {
    width: 100%;
  }

  td,
  th {
    text-align: left;
    padding: 8px;
  }

  .impression-tracker-tr {
    background-color: rgba(0, 146, 215, 0.09);
  }

  .impression-tracker-th {
    font-weight: 500;
    font-size: 14px;
    color: #404040;
  }

  .tracker-type-width {
    width: 155px;
  }

  .tracker-width {
    width: 71%;
  }

  .tracker-type-dropdown {
    .vs__dropdown-menu {
      min-width: auto !important;
      box-shadow: none !important;
      border: 1px solid #f1f1f5 !important;
    }

    .vs__dropdown-toggle {
      border: none !important;
      cursor: pointer !important;
    }

    .vs__dropdown-option--highlight {
      background: #f7fafe !important;
      color: #2c2c2c !important;
    }

    .vs__selected,
    .vs__open-indicator {
      color: #0092d7 !important;
    }

    ::placeholder {
      color: #0092d7 !important;
    }

    .vs__search {
      cursor: pointer;
    }
  }

  .impression-tracker-input-parent {
    .impression-tracker-input {
      width: 100%;
      height: 40px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      // text-indent: 12px;
      padding-right: 12px;
      padding-left: 12px;
    }

    ::placeholder {
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .tracker-actions {
    .speakol-plus {
      color: #0092d7;
      cursor: pointer;
      font-size: 14px !important;
    }

    .speakol-cancel {
      color: #db2828;
      cursor: pointer;
      font-size: 14px !important;
    }
  }

  tr:nth-child(even) {
    background-color: #f9fdfe;
  }
}

.add-tracker {
  margin-right: 5px;
}

.disableAddIcon,
.disableRemoveIcon {
  color: #d9d9d9 !important;
  cursor: no-drop !important;
}

.inputHasError {
  border: 1px solid red !important;
}

.impression-url-span {
  color: #0092d7;
  position: relative;
  top: 0;
}

.trackerTypeInputHasError,
.actionsInputHasError {
  position: relative;
  top: -9px;
}

@media (min-width: 1455px) {
  .tracker-width {
    width: 77% !important;
  }
}

@media (max-width: 576px) {
  .impression-url-span {
    position: relative;
    top: 0;
  }

  .tracker-type-width {
    width: 380px !important;
  }

  .actionsInputHasError {
    position: relative;
    top: 0;
  }

  .trackerTypeInputHasError {
    position: relative;
    top: -8px;
  }
}
</style>
